<script setup>
import { ref } from 'vue'
import { mdiChevronUp, mdiChevronDown } from '@mdi/js'

const { title, collapsed } = defineProps({ title: String, collapsed: { type: Boolean, default: true } })

const isCollapsed = ref(collapsed)

function toggleCollapsed() {
  isCollapsed.value = !isCollapsed.value
}
</script>

<template>
  <v-card>
    <div class="flex align-center cursor-pointer" @click="toggleCollapsed">
      <div class="grow text-title-large pa-4">
        {{ title }}
      </div>
      <div class="px-3 py-1">
        <v-btn :icon="isCollapsed ? mdiChevronDown : mdiChevronUp"></v-btn>
      </div>
    </div>
    <div :class="{ 'hidden': isCollapsed, 'block': !isCollapsed }">
      <slot />
    </div>
  </v-card>
</template>
